import React, { useState } from 'react';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ŽKK Olimp'];

function Igraci({ igraci, setAktivna, dodajIgraca, updateIgrac, obrisiIgraca, jeAdmin, jeGost, globalnaSezona }) {
  const [prikaz, setPrikaz] = useState('lista');
  const [filterKlub, setFilterKlub] = useState('svi');
  const [editIgrac, setEditIgrac] = useState(null);
  const [transferIgrac, setTransferIgrac] = useState(null);
  const [transferForma, setTransferForma] = useState({ uKlub: '', datum: '', sezona: globalnaSezona || '2026/2027', napomena: '' });
  const [forma, setForma] = useState({ ime: '', klub: KLUBOVI[0], slika: '', pin: '' });

  const filtrirani = igraci
    .filter(i => filterKlub === 'svi' || i.klub === filterKlub)
    .sort((a, b) => a.ime.localeCompare(b.ime));

  const handleDodaj = async () => {
    if (!forma.ime) return alert('Upiši ime igrača!');
    if (!forma.pin) return alert('Upiši PIN za igrača!');
    await dodajIgraca({ ime: forma.ime, klub: forma.klub, slika: forma.slika, pin: forma.pin });
    setForma({ ime: '', klub: KLUBOVI[0], slika: '', pin: '' });
    setPrikaz('lista');
    alert('Igrač dodan!');
  };

  const handleUpdate = async () => {
    if (!editIgrac.ime) return alert('Upiši ime igrača!');
    await updateIgrac(editIgrac.id, {
      ime: editIgrac.ime, klub: editIgrac.klub,
      slika: editIgrac.slika || '',
      pin: editIgrac.pin || '',
      jeTrener: editIgrac.jeTrener === true,
    });
    setEditIgrac(null);
    alert('Igrač ažuriran!');
  };

  const otvoriTransfer = (igrac) => {
    const ostaliKlubovi = KLUBOVI.filter(k => k !== igrac.klub);
    setTransferForma({
      uKlub: ostaliKlubovi[0] || KLUBOVI[0],
      datum: new Date().toISOString().split('T')[0],
      sezona: '2025/2026',
      napomena: '',
    });
    setTransferIgrac(igrac);
  };

  const handleTransfer = async () => {
    if (!transferForma.uKlub) return alert('Odaberi klub!');
    if (transferForma.uKlub === transferIgrac.klub) return alert('Igrač je već u tom klubu!');

    const noviTransfer = {
      izKluba: transferIgrac.klub,
      uKlub: transferForma.uKlub,
      datum: transferForma.datum,
      sezona: transferForma.sezona,
      napomena: transferForma.napomena || '',
    };

    const postojeciTransferi = transferIgrac.transferi || [];
    await updateIgrac(transferIgrac.id, {
      klub: transferForma.uKlub,
      transferi: [...postojeciTransferi, noviTransfer],
    });
    setTransferIgrac(null);
    alert(`${transferIgrac.ime} transferisan u ${transferForma.uKlub}. Statistike iz prethodnih sezona ostaju nepromijenjene.`);
  };

  return (
    <div>
      {/* Transfer modal */}
      {transferIgrac && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
        }}>
          <div className="card" style={{ maxWidth: '460px', width: '100%' }}>
            <div className="section-title" style={{ color: '#ffc107' }}>🔄 Transfer igrača</div>
            <p style={{ fontSize: '14px', color: '#aaa', marginBottom: '16px' }}>
              Transferiši <strong style={{ color: '#fff' }}>{transferIgrac.ime}</strong> iz{' '}
              <strong style={{ color: '#e94560' }}>{transferIgrac.klub}</strong> u novi klub.
              Statistike iz prethodnih sezona ostaju nepromijenjene — vezane su za stari klub.
            </p>
            <div className="form-row">
              <div className="form-group">
                <label>U klub</label>
                <select value={transferForma.uKlub}
                  onChange={e => setTransferForma({ ...transferForma, uKlub: e.target.value })}>
                  {KLUBOVI.filter(k => k !== transferIgrac.klub).map(k => <option key={k}>{k}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Sezona</label>
                <select value={transferForma.sezona}
                  onChange={e => setTransferForma({ ...transferForma, sezona: e.target.value })}>
                  <option>2025/2026</option>
                  <option>2026/2027</option>
                </select>
              </div>
              <div className="form-group">
                <label>Datum transfera</label>
                <input type="date" value={transferForma.datum}
                  onChange={e => setTransferForma({ ...transferForma, datum: e.target.value })} />
              </div>
              <div className="form-group" style={{ flexBasis: '100%' }}>
                <label>Napomena (opciono)</label>
                <input placeholder="npr. posudba, trajni transfer..." value={transferForma.napomena}
                  onChange={e => setTransferForma({ ...transferForma, napomena: e.target.value })}
                  style={{ width: '100%' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
              <button className="btn-primary" style={{ background: '#ffc107', borderColor: '#ffc107', color: '#000', fontWeight: '700' }}
                onClick={handleTransfer}>
                Potvrdi transfer
              </button>
              <button className="btn-secondary" onClick={() => setTransferIgrac(null)}>Odustani</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div className="page-title" style={{ margin: 0 }}>Igrači</div>
        {jeAdmin && prikaz === 'lista' && (
          <button className="btn-primary" onClick={() => setPrikaz('forma')}>+ Novi igrač</button>
        )}
        {jeAdmin && prikaz === 'forma' && (
          <button className="btn-secondary" onClick={() => setPrikaz('lista')}>← Nazad</button>
        )}
      </div>

      {prikaz === 'forma' && jeAdmin && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <div className="section-title">Dodaj novog igrača</div>
          <div className="form-row">
            <div className="form-group">
              <label>Ime i prezime</label>
              <input placeholder="npr. Marko Marković" value={forma.ime}
                onChange={e => setForma({ ...forma, ime: e.target.value })}
                style={{ width: '200px' }} />
            </div>
            <div className="form-group">
              <label>Klub</label>
              <select value={forma.klub} onChange={e => setForma({ ...forma, klub: e.target.value })}>
                {KLUBOVI.map(k => <option key={k}>{k}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>PIN kod</label>
              <input type="password" placeholder="npr. 1234" maxLength="6" value={forma.pin}
                onChange={e => setForma({ ...forma, pin: e.target.value })}
                style={{ width: '120px' }} />
            </div>
            <div className="form-group">
              <label>URL slike (opciono)</label>
              <input placeholder="https://..." value={forma.slika}
                onChange={e => setForma({ ...forma, slika: e.target.value })}
                style={{ width: '250px' }} />
            </div>
          </div>
          <button className="btn-primary" style={{ marginTop: '16px' }} onClick={handleDodaj}>
            Dodaj igrača
          </button>
        </div>
      )}

      <div className="filter-bar">
        {['svi', ...KLUBOVI].map(k => (
          <button key={k} className={`filter-btn ${filterKlub === k ? 'active' : ''}`}
            onClick={() => setFilterKlub(k)}>
            {k === 'svi' ? 'Svi klubovi' : k}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
        {filtrirani.map(igrac => (
          <div key={igrac.id} className="card" style={{ width: '280px', position: 'relative' }}>

            {editIgrac?.id === igrac.id ? (
              <div>
                <div className="section-title">Uredi igrača</div>
                <div className="form-group" style={{ marginBottom: '10px' }}>
                  <label>Ime i prezime</label>
                  <input value={editIgrac.ime}
                    onChange={e => setEditIgrac({ ...editIgrac, ime: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: '10px' }}>
                  <label>Klub</label>
                  <select value={editIgrac.klub}
                    onChange={e => setEditIgrac({ ...editIgrac, klub: e.target.value })}>
                    {KLUBOVI.map(k => <option key={k}>{k}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{ marginBottom: '10px' }}>
                  <label>PIN kod</label>
                  <input type="password" maxLength="6" value={editIgrac.pin || ''}
                    onChange={e => setEditIgrac({ ...editIgrac, pin: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: '10px' }}>
                  <label>URL slike</label>
                  <input value={editIgrac.slika || ''}
                    onChange={e => setEditIgrac({ ...editIgrac, slika: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={editIgrac.jeTrener === true}
                      onChange={e => { const v = e.target.checked; setEditIgrac(prev => ({ ...prev, jeTrener: v })); }} />
                    Trener (pristup planu treninga)
                  </label>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button className="btn-primary btn-sm" onClick={handleUpdate}>Sačuvaj</button>
                  <button className="btn-secondary btn-sm" onClick={() => setEditIgrac(null)}>Odustani</button>
                </div>
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', gap: '14px', alignItems: 'center', marginBottom: '14px' }}>
                  {igrac.slika ? (
                    <img src={igrac.slika} alt={igrac.ime}
                      style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #e94560', flexShrink: 0 }} />
                  ) : (
                    <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#12122a', border: '2px solid #e94560', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color: '#e94560', flexShrink: 0 }}>
                      {igrac.ime.charAt(0)}
                    </div>
                  )}
                  <div>
                    <div style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>{igrac.ime}</div>
                    <span className="badge badge-blue" style={{ marginTop: '4px' }}>{igrac.klub}</span>
                    {igrac.transferi?.length > 0 && (
                      <div style={{ marginTop: '4px', fontSize: '11px', color: '#ffc107' }}>
                        🔄 {igrac.transferi.length} transfer{igrac.transferi.length > 1 ? 'a' : ''}
                      </div>
                    )}
                  </div>
                </div>

                {/* Transfer istorija */}
                {igrac.transferi?.length > 0 && (
                  <div style={{ marginBottom: '12px', padding: '8px', background: 'rgba(255,193,7,0.06)', borderRadius: '6px', border: '1px solid rgba(255,193,7,0.15)' }}>
                    <div style={{ fontSize: '11px', color: '#ffc107', fontWeight: '600', marginBottom: '6px' }}>Istorija transfera</div>
                    {igrac.transferi.map((t, i) => (
                      <div key={i} style={{ fontSize: '11px', color: '#aaa', lineHeight: '1.6' }}>
                        <span style={{ color: '#888' }}>{t.sezona}</span> · {t.izKluba} → <strong style={{ color: '#fff' }}>{t.uKlub}</strong>
                        {t.datum && <span style={{ color: '#666688' }}> ({t.datum})</span>}
                        {t.napomena && <span style={{ color: '#666688' }}> — {t.napomena}</span>}
                      </div>
                    ))}
                  </div>
                )}

                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <button className="btn-secondary btn-sm"
                    onClick={() => setAktivna({ strana: 'profil', igracId: igrac.id })}>
                    📊 Statistike
                  </button>
                  {jeAdmin && (
                    <>
                      <button className="btn-edit btn-sm" onClick={() => setEditIgrac({ ...igrac })}>✏️ Uredi</button>
                      <button className="btn-sm"
                        style={{ background: 'rgba(255,193,7,0.12)', color: '#ffc107', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', padding: '4px 10px' }}
                        onClick={() => otvoriTransfer(igrac)}>
                        🔄 Transfer
                      </button>
                      <button className="btn-danger btn-sm"
                        onClick={() => { if (window.confirm(`Obrisati igrača ${igrac.ime}?`)) obrisiIgraca(igrac.id); }}>
                        Obriši
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}

        {filtrirani.length === 0 && (
          <div className="card empty-state" style={{ width: '100%' }}>
            <div className="icon">👤</div>
            <p>Nema igrača u ovom klubu.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Igraci;
